import { iconSize, IconSizeProps } from '@/types/icons';

export const IconContainer3 = ({ size }: IconSizeProps) => {
  return (
    <svg
      fill="currentColor"
      className={iconSize[size]}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
    >
      <path
        d="M6.67374 19L1.33337 16.7399V7.47534L6.67374 5M6.67374 19V5M6.67374 19L23.3334 17.1704V7.09865L6.67374 5"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path d="M10.3334 9.5V14.5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M14.8334 10V14" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M19.3334 10.5V13.5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}
